import React, { useState } from "react";
import { Link } from "react-router-dom";
import { api, formatApiErrorDetail } from "@/lib/api";
import { ArrowRight, Mail, CheckCircle2 } from "lucide-react";

export default function ForgotPassword() {
  const [email, setEmail] = useState("");
  const [busy, setBusy] = useState(false);
  const [sent, setSent] = useState(false);
  const [err, setErr] = useState("");

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true); setErr("");
    try {
      await api.post("/auth/forgot-password", { email });
      setSent(true);
    } catch (e) {
      setErr(formatApiErrorDetail(e.response?.data?.detail) || e.message);
    }
    setBusy(false);
  };

  return (
    <div className="min-h-screen flex items-center justify-center px-6 bg-white/[0.03] relative overflow-hidden">
      <div className="orb orb-violet w-[26rem] h-[26rem] -top-32 -left-32" aria-hidden="true" />
      <div className="orb orb-magenta w-[22rem] h-[22rem] bottom-[-10%] right-[-5%]" aria-hidden="true" />
      <div className="w-full max-w-md glass-panel rounded-3xl p-10 relative" data-testid="forgot-form">
        <Link to="/login" className="text-xs uppercase tracking-[0.2em] text-slate-200 hover:text-orange-300 mb-8 inline-block transition-colors">← Back to login</Link>

        {sent ? (
          <>
            <div className="w-14 h-14 rounded-2xl bg-orange-500/10 border border-orange-400/30 flex items-center justify-center mb-6">
              <CheckCircle2 className="text-orange-400" size={26} />
            </div>
            <h1 className="font-display text-3xl font-bold text-white mb-3">Check your email</h1>
            <p className="text-slate-200 mb-2">
              If an account exists for <span className="text-white font-medium">{email}</span>, we've sent a reset link.
            </p>
            <p className="text-slate-200 text-sm font-bn">The link stays valid for one hour.</p>
          </>
        ) : (
          <>
            <div className="w-14 h-14 rounded-2xl bg-orange-500/10 border border-orange-400/30 flex items-center justify-center mb-6">
              <Mail className="text-orange-400" size={24} />
            </div>
            <h1 className="font-display text-3xl font-bold text-white mb-3">Reset password</h1>
            <p className="text-slate-200 text-sm mb-8 font-bn">Enter your email and we'll send a reset link.</p>

            {err && <div className="mb-4 border border-red-500/30 bg-red-500/10 px-4 py-3 text-sm text-red-400 rounded-xl" data-testid="forgot-error">{err}</div>}

            <form onSubmit={submit}>
              <label className="block mb-1.5 text-xs uppercase tracking-widest text-slate-200 font-semibold">Email</label>
              <input
                type="email" required value={email} onChange={(e) => setEmail(e.target.value)}
                className="input-dark mb-6"
                data-testid="forgot-email"
              />
              <button type="submit" disabled={busy} className="btn-glow w-full justify-center" data-testid="forgot-submit">
                {busy ? "Sending…" : <>Send reset link <ArrowRight size={14} /></>}
              </button>
            </form>
          </>
        )}
      </div>
    </div>
  );
}
